<script lang="ts">
    import { cn } from "../cn";
    export let checked = false;
    export let disabled = false;
    export let title: string | undefined = undefined;
    let className = "";
    export { className as class };
</script>

<label
    class={cn(
        "relative inline-flex items-center justify-center cursor-pointer select-none size-4 rounded-md border transition-colors",
        checked
            ? "bg-[var(--primary)] border-[var(--primary)]"
            : "border-[var(--border)] bg-[var(--input)]/30 hover:border-[var(--primary)]/60",
        disabled && "opacity-50 cursor-not-allowed",
        className,
    )}
    {title}
>
    <input
        type="checkbox"
        bind:checked
        on:change
        {disabled}
        class="absolute inset-0 opacity-0 cursor-pointer disabled:cursor-not-allowed"
    />
    {#if checked}
        <svg
            width="11"
            height="11"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-[var(--primary-foreground)] pointer-events-none"
        >
            <polyline points="3 8 7 12 13 4" />
        </svg>
    {/if}
</label>
